module.exports = __webpack_public_path__ + "img/logo11.3f4b23a7.png";